import { VlogAllPlaylist } from "@modules/study/vlog";
import { LayoutMain } from "@unisearch/theme/layout";
import React from "react";
import API from "@unisearch/helpers/api";
import dynamic from "next/dynamic";
const VlogRecentVideos = dynamic(() => import("@modules/study/vlog/vlog"), {
  ssr: false,
});

const VlogPlaylist = ({ vlogPlaylist }) => {
  return (
    <LayoutMain
      title={"Vlog Playlist"}
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/vlog/playlist`}
      footer_with_evaluation
    >
      <VlogAllPlaylist vlogPlaylist={vlogPlaylist} />
      <VlogRecentVideos />
    </LayoutMain>
  );
};

export default VlogPlaylist;

export async function getServerSideProps({ query }) {
  let props = {
    vlogPlaylist: "",
    recentVideo: "",
  };

  let page_limit = 20;
  let current_page = 1;

  const { limit, page } = query;

  if (limit && page) {
    page_limit = limit;
    current_page = page;
  } else {
    page_limit = 20;
    current_page = 1;
  }

  try {
    await API.get(
      `/public/vlog/playlist?limit=${page_limit}&page=${current_page}`
    ).then((resp) => {
      if (!resp.error && resp.data) {
        props.vlogPlaylist = resp.data;
      } else {
        props.vlogPlaylist = "";
      }
    });

    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
